import React, { useState } from 'react';

import { Check, Mail, Lock, EyeOff, Eye } from 'lucide-react';

const LoginForm = ({ onSubmit, isLoading }) => {
  const [userType, setUserType] = useState('vendedor');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ userType, email, password, rememberMe });
  };
  
  return (
    <div className="w-full max-w-md">
      <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-100">
        <h2 className="text-2xl font-bold text-gray-800 text-center mb-1">Acesso à Plataforma</h2>
        <p className="text-gray-500 text-center mb-8">Digite suas credenciais para continuar</p>
        
        {/* User Type Selection */}
        <div className="bg-gray-100 rounded-md p-1 flex mb-6">
          <button
            className={`flex-1 py-2 text-center rounded-md transition ${
              userType === 'vendedor' 
                ? 'bg-blue-900 text-white' 
                : 'text-gray-600 hover:bg-gray-200'
            }`}
            onClick={() => setUserType('vendedor')}
            type="button"
          >
            Vendedor
          </button>
          <button
            className={`flex-1 py-2 text-center rounded-md transition ${
              userType === 'cliente' 
                ? 'bg-blue-900 text-white' 
                : 'text-gray-600 hover:bg-gray-200'
            }`}
            onClick={() => setUserType('cliente')}
            type="button"
          >
            Cliente
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          {/* Email Input */}
          <div className="mb-4">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
              E-mail
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Mail className="h-5 w-5 text-gray-400" />
              </div>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="pl-10 block w-full rounded-md border border-gray-300 py-3 px-4 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-900 focus:border-blue-900"
                placeholder="email@exemplo.com"
                required
              />
            </div>
          </div>
          
          {/* Password Input */}
          <div className="mb-6">
            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
              Senha
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Lock className="h-5 w-5 text-gray-400" />
              </div>
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="pl-10 block w-full rounded-md border border-gray-300 py-3 px-4 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-900 focus:border-blue-900"
                placeholder="••••••••"
                required
              />
              <div 
                className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <EyeOff className="h-5 w-5 text-gray-400" />
                ) : (
                  <Eye className="h-5 w-5 text-gray-400" />
                )}
              </div>
            </div>
          </div>
          
          {/* Remember & Forgot */}
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center">
              <div 
                className={`w-5 h-5 rounded border cursor-pointer flex items-center justify-center ${
                  rememberMe ? 'bg-blue-900 border-blue-900' : 'border-gray-300'
                }`}
                onClick={() => setRememberMe(!rememberMe)}
              >
                {rememberMe && <Check size={16} className="text-white" />}
              </div>
              <label htmlFor="remember" className="ml-2 block text-sm text-gray-700 cursor-pointer" onClick={() => setRememberMe(!rememberMe)}>
                Lembrar-me
              </label>
            </div>
            <div>
              <a href="#" className="text-sm font-medium text-blue-900 hover:text-blue-800">
                Esqueci minha senha
              </a>
            </div>
          </div>
          
          {/* Login Button */}
          <button
            type="submit"
            className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-900 hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-900"
            disabled={isLoading}
          >
            {isLoading ? 'CARREGANDO...' : 'ENTRAR'}
          </button>
        </form>
        
        {/* Alternative Login */}
        <div className="mt-6">
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 bg-white text-gray-500">ou acesse com</span>
            </div>
          </div>
          
          <div className="mt-6 grid grid-cols-3 gap-3">
            <div>
              <a href="#" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                G
              </a>
            </div>
            <div>
              <a href="#" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                f
              </a>
            </div>
            <div>
              <a href="#" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                in
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;